export default __webpack_public_path__ + "static/media/reset.38bae515.svg";